import React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import {
  Activity,
  Company,
  Customer,
  CustomerTransaction,
  RedemptionsRequest,
  TransferRequest,
} from "../../helpers/shared-interfaces";
import Modal from "../Modal";
import GlobalForm from "./GlobalForm";

interface Props extends RouteComponentProps {
  isOpen: boolean;
  onClose: () => void;
}

export type ItemClickProps = {
  id: string;
  type: string;
  segment: string;
  data:
    | Customer
    | Company
    | RedemptionsRequest
    | TransferRequest
    | CustomerTransaction
    | Activity;
};

class GlobalFormModal extends React.Component<Props> {
  render(): JSX.Element {
    const { isOpen, onClose, history } = this.props;

    const handleItemClick = ({ id, data, type, segment }: ItemClickProps) => {
      onClose();

      history.push({
        pathname: `/${segment}/${id}`,
        state: { data, type },
      });
    };

    if (!isOpen) return <></>;

    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        component={<GlobalForm handleItemClick={handleItemClick} />}
      />
    );
  }
}

export default withRouter(GlobalFormModal);
